<template>
  <div id="wrapper-dashboard-index">
    <b-container fluid class="p-0">
      <b-row no-gutters>
        <b-col lg="auto" class="col-left">
          <LmColumnMenu :menuItems="mainMenuItems"></LmColumnMenu>
        </b-col>
        <b-col class="col-right">
          <LmHeader />
          <router-view />
          <LmFooter />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LmColumnMenu from '../../components/LmColumnMenu.vue'
import LmHeader from '../../components/LmHeader.vue'
import LmFooter from '../../components/LmFooter.vue'

export default {
  computed: {
    ...mapState('settings', ['mainMenuItems', 'loading'])
  },
  methods: {
    ...mapActions('settings', ['getMainMenuSettings'])
  },
  created () {
    this.getMainMenuSettings()
  },
  components: {
    LmColumnMenu,
    LmHeader,
    LmFooter
  }
}
</script>

<style lang="sass" scoped>
  .col-right
    display: flex
    flex-direction: column
  .col-left
    flex: 0 1 235px
</style>
